var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDigitalP3CrossHair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9987 45.6654C36.4126 45.6654 45.6654 36.4126 45.6654 24.9987C45.6654 13.5848 36.4126 4.33203 24.9987 4.33203C13.5848 4.33203 4.33203 13.5848 4.33203 24.9987C4.33203 36.4126 13.5848 45.6654 24.9987 45.6654Z",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6671 25H37.4004",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5987 25H4.33203",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5987V4.33203",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45.6671V37.4004",
    stroke: "#FF5368",
    strokeWidth: 3.2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalP3CrossHair);
export default __webpack_public_path__ + "static/media/Digital_P3_CrossHair.494db056ec61191ca620d7c4af573573.svg";
export { ForwardRef as ReactComponent };